// extracted by mini-css-extract-plugin
module.exports = {"HeaderCard":"CompanyProfileView_HeaderCard__XNk6t","InnerDiv":"CompanyProfileView_InnerDiv__3_2gG"};